import { render, staticRenderFns } from "./FixedLink.vue?vue&type=template&id=1260d829"
import script from "./FixedLink.vue?vue&type=script&lang=js"
export * from "./FixedLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports